var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductsEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 799.031,
    height: 618.111,
    viewBox: "0 0 799.031 618.111",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-560.484 -230.944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.18,488.763c0,.872.478,1.573,1.073,1.573h535.1c.6,0,1.073-.7,1.073-1.573s-.478-1.573-1.073-1.573H16.253C15.658,487.191,15.18,487.891,15.18,488.763Z",
    transform: "translate(675.965 358.719)",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.105,
    height: 3.371,
    transform: "translate(865.646 842.297)",
    fill: "#94a3b8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.105,
    height: 3.371,
    transform: "translate(1034.779 842.859)",
    fill: "#94a3b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.955,370.945a27.529,27.529,0,0,1-54.321,0H229.146V521.536h193.3V370.945Z",
    transform: "translate(634.205 321.322)",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 193.296,
    height: 5.242,
    transform: "translate(863.914 830.926)",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.255,487.17H10.776A10.788,10.788,0,0,1,0,476.394V32.688A10.788,10.788,0,0,1,10.776,21.911H788.255a10.789,10.789,0,0,1,10.776,10.776V476.394a10.789,10.789,0,0,1-10.776,10.776Z",
    transform: "translate(560.484 209.033)",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 760.822,
    height: 429.297,
    transform: "translate(580.031 248.922)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.583,383.446H334.712a5.156,5.156,0,0,1-5.151-5.151V64.442a5.156,5.156,0,0,1,5.151-5.151H865.583a5.156,5.156,0,0,1,5.151,5.151V378.295A5.156,5.156,0,0,1,865.583,383.446ZM334.712,61.352a3.094,3.094,0,0,0-3.09,3.09V378.295a3.094,3.094,0,0,0,3.09,3.09H865.583a3.094,3.094,0,0,0,3.09-3.09V64.442a3.094,3.094,0,0,0-3.09-3.09Z",
    transform: "translate(359.853 233.559)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.541,94.317a4.084,4.084,0,1,0,0,8.168H736.928a4.084,4.084,0,0,0,.146-8.167H634.541Z",
    transform: "translate(274.287 223.6)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.353,92.635a.8.8,0,0,0,0,1.136h0l3.45,3.45H804.3a.8.8,0,0,0,0,1.607H812.8l-3.45,3.45a.8.8,0,0,0,1.136,1.136h0l4.821-4.821a.8.8,0,0,0,0-1.136l-4.821-4.821a.8.8,0,0,0-1.136,0Z",
    transform: "translate(225.081 224.145)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.2,92.635a.8.8,0,0,1,0,1.136h0l-3.45,3.45h8.506a.8.8,0,0,1,0,1.607h-8.508l3.45,3.45a.8.8,0,0,1-1.136,1.136h0l-4.821-4.821a.8.8,0,0,1,0-1.136l4.821-4.821a.8.8,0,0,1,1.136,0Z",
    transform: "translate(284.369 224.145)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.779,517.706a23.537,23.537,0,1,1,23.537-23.537,23.537,23.537,0,0,1-23.537,23.537Z",
    transform: "translate(908.612 122.836)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.806,496.587H326.84v-6.965a2.322,2.322,0,1,0-4.644,0v6.965h-6.965a2.322,2.322,0,1,0,0,4.644H322.2V508.2a2.322,2.322,0,0,0,4.644,0V501.23h6.965a2.322,2.322,0,0,0,0-4.644Z",
    transform: "translate(903.872 118.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.737,
    height: 48.074,
    transform: "translate(732.337 359.725)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.737,
    height: 48.074,
    transform: "translate(828.484 359.725)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.737,
    height: 48.074,
    transform: "translate(924.633 359.725)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.737,
    height: 48.074,
    transform: "translate(1020.779 359.725)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.737,
    height: 48.074,
    transform: "translate(1116.926 359.725)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.737,
    height: 48.074,
    transform: "translate(732.596 444.197)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.737,
    height: 48.074,
    transform: "translate(828.743 444.197)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.737,
    height: 48.074,
    transform: "translate(924.891 444.197)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.737,
    height: 48.074,
    transform: "translate(1021.038 444.197)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.737,
    height: 48.074,
    transform: "translate(1117.186 444.197)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.737,
    height: 48.074,
    transform: "translate(732.855 528.668)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.737,
    height: 48.074,
    transform: "translate(829.003 528.668)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.737,
    height: 48.074,
    transform: "translate(925.151 528.668)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.737,
    height: 48.074,
    transform: "translate(1021.298 528.668)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.737,
    height: 48.074,
    transform: "translate(1117.445 528.668)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.928,
    cy: 8.928,
    rx: 8.928,
    ry: 8.928,
    transform: "translate(930.385 365.906)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.928,
    cy: 8.928,
    rx: 8.928,
    ry: 8.928,
    transform: "translate(832.863 450.377)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.928,
    cy: 8.928,
    rx: 8.928,
    ry: 8.928,
    transform: "translate(930.385 534.85)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.928,
    cy: 8.928,
    rx: 8.928,
    ry: 8.928,
    transform: "translate(1028.593 450.377)",
    fill: "#64748b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.928,
    cy: 8.928,
    rx: 8.928,
    ry: 8.928,
    transform: "translate(1124.055 450.377)",
    fill: "#64748b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.928,
    cy: 8.928,
    rx: 8.928,
    ry: 8.928,
    transform: "translate(832.863 534.85)",
    fill: "#64748b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.928,
    cy: 8.928,
    rx: 8.928,
    ry: 8.928,
    transform: "translate(1124.055 365.906)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsEmptyState);
export default __webpack_public_path__ + "static/media/products-empty-state.7a5e6421ea1ee023f6640fe8b47a9de6.svg";
export { ForwardRef as ReactComponent };